// start:ng42.barrel
export * from './errors';
export * from './reservation';
export * from './hotel';
export * from './message';
export * from './guest';
export * from './user';
export * from './featureflags';
export * from './past-stay';
export * from './target-system.model';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/index.ts